export default "dist/images/components-design-separator-control-curve-1.277a020.png";